import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Button, Pagination, Table } from 'react-bootstrap';
import { AnchorComponent } from "../../elements";

export default function StockKeeperProductsTableComponent({
    thead,
    tbody,
    activeTab,
    selectedProductIds = [],
    setSelectedProductIds,
    onSingleReceived
}) {
    const { t } = useContext(TranslatorContext);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    useEffect(() => {
        setData(tbody || []);
        setCurrentPage(1);
    }, [tbody, activeTab]);

    // Helper to strip raw HTML tags like <p> from descriptions
    const stripHtml = (html) => {
        if (!html) return "N/A";
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    const handleCheckboxChange = (id) => {
        if (selectedProductIds.includes(id)) {
            setSelectedProductIds(selectedProductIds.filter(item => item !== id));
        } else {
            setSelectedProductIds([...selectedProductIds, id]);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedProductIds(currentData.map(item => item.id));
        } else {
            setSelectedProductIds([]);
        }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    return (
        <div className="table-responsive w-100" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            <Table className="mc-table product align-middle mb-0" hover style={{ minWidth: "950px" }}>
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => {
                            const isSelectCol = index === 0 && activeTab === "new";
                            return (
                                <th key={index} className="text-nowrap" style={isSelectCol ? { width: "45px", minWidth: "45px", textAlign: "center" } : {}}>
                                    {isSelectCol ? (
                                        <input
                                            type="checkbox"
                                            onChange={handleSelectAll}
                                            checked={currentData.length > 0 && currentData.every(item => selectedProductIds.includes(item.id))}
                                        />
                                    ) : t(item)}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {currentData && currentData.length > 0 ? (
                        currentData.map((item, index) => {
                            const pImage = item?.images?.[0]?.image ? `${process.env.REACT_APP_IMG_URL}${item.images[0].image}` : "";
                            const pTitle = item?.title || "N/A";
                            const pDescribe = stripHtml(item?.short_description || item?.description);
                            const pCode = item?.product_code || "N/A";
                            const pCategory = item?.category?.name || "N/A";
                            const pBrand = item?.brand?.name || "N/A";
                            const pricePresent = item?.sell_price_dollar || 0;

                            return (
                                <tr key={item?.id || index}>
                                    {activeTab === "new" && (
                                        <td className="text-center align-middle" style={{ width: "45px", minWidth: "45px" }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedProductIds.includes(item?.id)}
                                                onChange={() => handleCheckboxChange(item?.id)}
                                            />
                                        </td>
                                    )}

                                    <td className="align-middle" style={{ width: "160px", minWidth: "160px" }}>
                                        <span className="text-break">{pCode}</span>
                                    </td>

                                    <td className="align-middle" style={{ width: "220px", minWidth: "220px" }}>
                                        <div className="mc-table-product md d-flex align-items-center gap-2">
                                            {pImage && <img src={pImage} alt={pTitle} style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px", flexShrink: 0 }} />}
                                            <div className="mc-table-group" style={{ overflow: "hidden" }}>
                                                <h6 className="mb-0 text-truncate" title={pTitle}>{pTitle}</h6>
                                                <p className="mb-0 text-muted small text-truncate" title={pDescribe}>{pDescribe}</p>
                                            </div>
                                        </div>
                                    </td>

                                    <td className="align-middle" style={{ width: "180px", minWidth: "180px" }}>
                                        <div className="d-flex flex-column text-break" style={{ fontSize: "13px", lineHeight: "1.4" }}>
                                            <span><strong>{t("Category")}:</strong> {pCategory}</span>
                                            <span><strong>{t("Brand")}:</strong> {pBrand}</span>
                                        </div>
                                    </td>

                                    <td className="align-middle text-nowrap" style={{ width: "110px", minWidth: "110px" }}>
                                        <p className="mb-0 fw-semibold text-success">${pricePresent}</p>
                                    </td>

                                    <td className="align-middle text-nowrap" style={{ width: "140px", minWidth: "140px" }}>
                                        <div className="mc-table-action d-flex align-items-center gap-2">
                                            <AnchorComponent
                                                to={`/stock-keeper-product-view/${item?.id || ''}`}
                                                state={{ item }}
                                                title="View"
                                                className="material-icons view"
                                            >
                                                visibility
                                            </AnchorComponent>

                                            {activeTab === "new" && (
                                                <Button
                                                    size="sm"
                                                    style={{ backgroundColor: "#28a745", borderColor: "#28a745", color: "#fff" }}
                                                    onClick={() => onSingleReceived && onSingleReceived(item?.id)}
                                                >
                                                    Recieved
                                                </Button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 6} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {totalPages > 1 && (
                <div className="d-flex justify-content-end mt-4 px-3">
                    <Pagination>
                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </div>
            )}
        </div>
    );
}